<template>
  <div class="building-owner-form">
    <b-row v-if="isAsl">
      <b-col cols="12">
        <div class="mt-3"><h5>Le nom du volume</h5></div>
        <v-select
          v-model="buildingOwner.building_asl_id"
          class="w-100"
          :options="buildingsAsl"
          label="text"
          :reduce="item => item.value"
          placeholder="Choisissez le volume"
          @input="updateBuildingOwner('building_asl_id', $event)"
        >
        </v-select>
      </b-col>
    </b-row>
    <b-row v-if="isAsl">
      <b-col cols="12">
        <div class="mt-3"><h5>Le representational légal:</h5></div>
      </b-col>
    </b-row>
    <!-- gender | lastname | firstname | email -->
    <b-row class="mb-3 mt-2 justify-content-center">
      <b-col cols="6">
        <b-button
          class="btn-block"
          squared
          :class="{
            'agv btn-primary': buildingOwner.entity_type == entityTypes.individual,
            'agv btn-outline-primary': buildingOwner.entity_type != entityTypes.individual,
          }"
          variant="none"
          @click="setEntityType(entityTypes.individual)"
        >
          <strong>Particulier</strong>
        </b-button>
      </b-col>
      <b-col cols="6">
        <b-button
          class="btn-block"
          squared
          variant="none"
          :class="{
            'agv btn-primary': buildingOwner.entity_type == entityTypes.legal,
            'agv btn-outline-primary': buildingOwner.entity_type != entityTypes.legal,
          }"
          @click="setEntityType(entityTypes.legal)"
        >
          <strong>Professionnel</strong>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col v-if="buildingOwner.entity_type == entityTypes.individual" sm="3" md="2">
        <label>{{ $t("general.Civilité") }}</label>
        <b-form-select
          :value="buildingOwner.gender"
          :options="genderOptions"
          @change="updateBuildingOwner('gender', $event)"
        />
      </b-col>
      <b-col v-if="buildingOwner.entity_type == entityTypes.individual" sm="4" md="3">
        <label>{{ $t("general.Nom") }}</label>
        <ValidationProvider
          ref="vee-b-owner-lastname"
          v-slot="{ errors, classes }"
          :name="'nom'"
          rules="required"
        >
          <b-input
            :value="buildingOwner.lastname"
            @input="updateBuildingOwner('lastname', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col v-if="buildingOwner.entity_type == entityTypes.individual" sm="4" md="3">
        <label>{{ $t("general.Prénom") }}</label>
        <b-input
          :value="buildingOwner.firstname"
          @input="updateBuildingOwner('firstname', $event)"
        />
      </b-col>

      <b-col v-if="buildingOwner.entity_type == entityTypes.legal" sm="7" md="6">
        <label>Raison sociale</label>
        <ValidationProvider
          ref="vee-b-owner-lastname"
          v-slot="{ errors, classes }"
          :name="'raison sociale'"
          rules="required"
        >
          <b-input
            :value="buildingOwner.lastname"
            @input="updateBuildingOwner('lastname', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>

      <b-col sm="6" md="4">
        <label>{{ $t("general.Email") }}</label>
        <ValidationProvider
          ref="vee-b-owner-email"
          v-slot="{ errors, classes }"
          :name="'email'"
          :rules="
            buildingOwner.contact_type == contactTypes.email ||
            (buildingOwner.settings && buildingOwner.settings.lre_agreement)
              ? 'required|email'
              : 'email'
          "
        >
          <b-input :value="buildingOwner.email" @input="updateBuildingOwner('email', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <!-- street nb | street | address second -->
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col sm="6" md="6">
        <label>Adresse</label>
        <ValidationProvider
          ref="vee-b-owner-address"
          v-slot="{ errors, classes }"
          :name="'adresse'"
          rules="required"
        >
          <b-input :value="buildingOwner.address" @input="updateBuildingOwner('address', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col sm="6" md="6">
        <label>{{ $t("general.Complément") }}</label>
        <b-input
          :value="buildingOwner.complement"
          @input="updateBuildingOwner('complement', $event)"
        />
      </b-col>
    </b-row>
    <!-- zipcode | city | country -->
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col sm="3" md="2">
        <label>{{ $t("general.Code_postal") }}</label>
        <ValidationProvider
          ref="vee-b-owner-zipcode"
          v-slot="{ errors, classes }"
          :name="'code postal'"
          rules="required"
        >
          <b-input :value="buildingOwner.zipcode" @input="updateBuildingOwner('zipcode', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col sm="4" md="3">
        <label>Ville</label>
        <ValidationProvider
          ref="vee-b-owner-city"
          v-slot="{ errors, classes }"
          :name="'ville'"
          rules="required"
        >
          <b-input :value="buildingOwner.city" @input="updateBuildingOwner('city', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col sm="4" md="3">
        <label>{{ $t("general.Pays") }}</label>
        <ValidationProvider
          ref="vee-b-owner-country"
          v-slot="{ errors, classes }"
          :name="'pays'"
          rules="required"
        >
          <b-form-select
            :value="buildingOwner.country.toUpperCase()"
            :options="countryOptions"
            @input="updateBuildingOwner('country', $event)"
          >
            <template #first>
              <b-form-select-option :value="''" disabled>Choisissez le pays</b-form-select-option>
            </template>
          </b-form-select>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>

      <b-col sm="5" md="4">
        <label>Complément 2</label>
        <b-input
          :value="buildingOwner.complement2"
          @input="updateBuildingOwner('complement2', $event)"
        />
      </b-col>
    </b-row>
    <!-- contact type -->
    <b-row class="mb-4 mx-sm-0">
      <b-col sm="6" md="5">
        <label>{{ $t("general.Type_d_envoi_prefere") }}</label>
        <ValidationProvider
          ref="vee-b-owner-contact_type"
          v-slot="{ errors, classes }"
          :name="'type d’envoi préféré'"
          rules="required"
        >
          <b-form-select
            :value="buildingOwner.contact_type"
            :options="customContactTypeOptions"
            @change="updateBuildingOwner('contact_type', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mb-4 mx-sm-0">
      <b-col cols="12" class="d-flex align-items-end">
        <b-form-checkbox
          v-model="lreAgreement"
          class="ml-2"
          :value="true"
          :unchecked-value="false"
          @change="updateLreAgreement($event)"
        >
          <span>{{ $t("general.Lre_agreement") }}</span>
        </b-form-checkbox>
      </b-col>
      <b-col cols="12" class="d-flex align-items-end">
        <b-form-checkbox
          v-model="lreRefusal"
          class="ml-2"
          :value="true"
          :unchecked-value="false"
          @change="updateLreRefusal($event)"
        >
          <span>{{ $t("general.Lre_refusal") }}</span>
        </b-form-checkbox>
      </b-col>
      <b-col cols="12">
        <label>{{ $t("general.Lre_agreement_media") }}</label>
        <appLreAgreementFileUploader
          :lre-agreement-media="lreAgreementMedia"
          @updateFileRecords="updateFileRecords"
          @deleteFileRecord="deleteFileRecord"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import appLreAgreementFileUploader from "./LreAgreementFileUploader";
import BuildingORM from "@/store/orm-axios/models/Building";
export default {
  components: {
    appLreAgreementFileUploader,
  },
  props: {
    buildingOwner: {
      type: Object,
      default: () => {
        return {};
      },
    },
    allCountries: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    buildingsAsl: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      lreAgreement: false,
      lreRefusal: false,
      lreAgreementMedia: null,
    };
  },
  computed: {
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
    customContactTypeOptions() {
      // NOTE: DEV-5159 -> We remove lre option and determine if send to lre from api
      if (this.lreAgreement) {
        return this.contactTypeOptions.filter(option => option.key != "remise_en_main_propre");
      } else {
        return this.contactTypeOptions;
      }
    },
    isAsl() {
      return this.$route.path.includes("asl");
    },
  },
  watch: {
    lreAgreement(newVal, oldVal) {
      if (newVal == false && newVal != oldVal) {
        // NOTE: On lreAgreement change, set default to courrier_postal
        this.$emit("updateBuildingOwner", "contact_type", 1);
      }
    },
  },
  created() {
    this.isCountryValid();
    this.initBOSettingsField();
  },
  methods: {
    updateBuildingOwner(key, value) {
      this.$emit("updateBuildingOwner", key, value);
    },
    setEntityType(type) {
      this.$emit("updateBuildingOwner", "entity_type", type);
      if (type == this.entityTypes.legal) {
        this.$emit("updateBuildingOwner", "gender", 0);
      }
    },
    isCountryValid() {
      let found = this.$_.find(this.allCountries, country => {
        return country.countryCode.toUpperCase() == this.buildingOwner.country.toUpperCase();
      });
      if (found === undefined) {
        this.updateBuildingOwner("country", "");
      }
    },
    initBOSettingsField() {
      let settings = this.buildingOwner.settings ? this.buildingOwner.settings : {};
      if (settings.lre_agreement == undefined) {
        settings["lre_agreement"] = false;
        this.updateBuildingOwner("settings", settings);
      } else {
        this.lreAgreement = this.buildingOwner.settings.lre_agreement;
      }
      if (settings.lre_refusal == undefined) {
        settings["lre_refusal"] = false;
        this.updateBuildingOwner("settings", settings);
      } else {
        this.lreRefusal = this.buildingOwner.settings.lre_refusal;
      }
      if (settings.lre_agreement_media == undefined) {
        settings["lre_agreement_media"] = null;
        this.updateBuildingOwner("settings", settings);
      } else {
        this.lreAgreementMedia = this.buildingOwner.settings.lre_agreement_media;
      }
    },
    updateLreAgreement(event) {
      let settings = this.buildingOwner.settings;
      settings.lre_agreement = event;
      // If agreement is checked, uncheck refusal
      if (event === true) {
        settings.lre_refusal = false;
        this.lreRefusal = false;
      }
      this.updateBuildingOwner("settings", settings);
    },
    updateLreRefusal(event) {
      let settings = this.buildingOwner.settings;
      settings.lre_refusal = event;
      // If refusal is checked, uncheck agreement
      if (event === true) {
        settings.lre_agreement = false;
        this.lreAgreement = false;
      }
      this.updateBuildingOwner("settings", settings);
    },
    updateLreAgreementMedia() {
      let settings = this.buildingOwner.settings;
      settings.lre_agreement_media = this.lreAgreementMedia;
      this.updateBuildingOwner("settings", settings);
    },
    updateFileRecords(fileRecords) {
      fileRecords.forEach(fileRecord => {
        if (this.lreAgreementMedia && this.lreAgreementMedia.id != fileRecord.media.id) {
          this.lreAgreementMedia = {
            id: fileRecord.media.id,
            name: fileRecord.media.name,
            file_path: fileRecord.media.file_path,
          };
        } else {
          this.lreAgreementMedia = {
            id: fileRecord.media.id,
            name: fileRecord.media.name,
            file_path: fileRecord.media.file_path,
          };
        }
      });
      this.updateLreAgreementMedia();
    },
    deleteFileRecord(fileRecord) {
      this.lreAgreementMedia = null;
      this.updateLreAgreementMedia();
      this.updateBuildingOwner("mediaFileToDelete", fileRecord.media);
    },
  },
};
</script>
